module.exports = __webpack_public_path__ + "img/p2.c6ad084e.png";